/*
 * One Kickz — carga diferida de las pestanias de "Featured products" (14/09/2026).
 *
 * Antes: el HTML de la home traia TODAS las pestanias renderizadas (8 tarjetas x N
 * pestanias) y el JS solo hacia display:none. Ahora la primera pestania viene en el
 * HTML y el resto se piden por fetch a /collections/<handle>?view=tab la primera vez
 * que se usan, con prefetch al pasar el mouse y en tiempo libre del navegador.
 *
 * Cada contenedor diferido es <div class="products-feed__lazy" data-tab-url=...>
 * y al inyectar el HTML se crea un <swiper-component>, que se inicializa solo.
 *
 * 16/09/2026: si la pestania tiene un <template class="products-feed__shop-all-tpl">,
 * su contenido se agrega como ULTIMO slide (tarjeta "Shop all").
 *
 * 16/09/2026: en layout 2 las flechas de navegacion se centran a la altura de la
 * foto (variable --ok-nav-top), asi quedan alineadas con el icono de "Shop all".
 * Se mide la posicion REAL de las flechas contra el centro de la foto y se corrige
 * la diferencia, asi no depende de cual sea el contenedor de referencia.
 */
(function () {
  var cache = {};

  function slidesMarkup(count) {
    var out = '';
    for (var i = 0; i < count; i++) {
      out +=
        '<div class="swiper-slide card-product-slider__slide products-feed__skeleton-slide">' +
        '<div class="products-feed__skeleton-media"></div>' +
        '<div class="products-feed__skeleton-line"></div>' +
        '<div class="products-feed__skeleton-line products-feed__skeleton-line--short"></div>' +
        '</div>';
    }
    return '<div class="swiper-wrapper card-product-slider__wrapper">' + out + '</div>';
  }

  function showSkeleton(el) {
    if (el.dataset.skeleton === 'done') return;
    el.dataset.skeleton = 'done';
    el.innerHTML = slidesMarkup(4);
  }

  function fetchTab(url) {
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var wrapper = doc.querySelector('.swiper-wrapper');
        return wrapper && wrapper.innerHTML.trim().length ? wrapper.outerHTML : '';
      })
      .catch(function (e) {
        console.error('[featured-products] no se pudo cargar la pestania', url, e);
        delete cache[url];
        return '';
      });
    return cache[url];
  }

  function appendShopAll(el, html) {
    var panel = el.parentElement;
    var tpl = panel ? panel.querySelector('template.products-feed__shop-all-tpl') : null;
    if (!tpl) return html;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var wrapper = tmp.querySelector('.swiper-wrapper');
    if (!wrapper) return html;
    wrapper.insertAdjacentHTML('beforeend', tpl.innerHTML);
    return tmp.innerHTML;
  }

  /* Centra las flechas (layout 2) a la altura de la primera foto visible.
     Mide donde estan hoy las flechas y corrige la diferencia contra el centro de la foto. */
  function alignNav(section) {
    var buttons = section.querySelector('.swiper-buttons');
    if (!buttons) return;
    var b = buttons.getBoundingClientRect();
    if (!b.height) return; // oculto (mobile)

    var medias = section.querySelectorAll('.product-card__media, .products-feed__shop-all, .products-feed__skeleton-media');
    var media = null;
    for (var i = 0; i < medias.length; i++) {
      if (medias[i].getClientRects().length && medias[i].offsetHeight > 0) {
        media = medias[i];
        break;
      }
    }
    if (!media) return;
    var m = media.getBoundingClientRect();

    var delta = (m.top + m.height / 2) - (b.top + b.height / 2);
    if (Math.abs(delta) < 1) return;

    var currentTop = parseFloat(window.getComputedStyle(buttons).top) || 0;
    section.style.setProperty('--ok-nav-top', Math.round(currentTop + delta) + 'px');
  }

  function bindAlign() {
    document.querySelectorAll('.section-featured-products.layout-2').forEach(function (section) {
      if (section.dataset.navAligned === 'true') {
        alignNav(section);
        return;
      }
      section.dataset.navAligned = 'true';
      alignNav(section);
      if (window.ResizeObserver) {
        var queued = false;
        new ResizeObserver(function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            alignNav(section);
          });
        }).observe(section);
      } else {
        window.addEventListener('resize', function () {
          alignNav(section);
        });
      }
    });
  }

  function render(el) {
    if (el.dataset.loaded === 'true' || el.dataset.loading === 'true') return;
    var url = el.getAttribute('data-tab-url');
    if (!url) return;
    el.dataset.loading = 'true';
    showSkeleton(el);

    fetchTab(url).then(function (html) {
      el.dataset.loading = 'false';
      if (!html) {
        el.innerHTML = '';
        return;
      }
      html = appendShopAll(el, html);
      var opts = el.getAttribute('data-swiper-options') || '{}';
      var sectionId = el.getAttribute('data-section-id') || '';
      el.innerHTML =
        '<swiper-component class="swiper card-product-slider" data-section-id="' +
        sectionId +
        '" data-swiper-options=\'' +
        opts +
        '\'>' +
        html +
        '</swiper-component>';
      el.dataset.loaded = 'true';

      el.querySelectorAll('product-card').forEach(function (card) {
        if (typeof card.init === 'function') card.init();
      });
      var quickCart = document.querySelector('quick-cart-drawer');
      if (quickCart && typeof quickCart.init === 'function') quickCart.init();

      var section = el.closest('.section-featured-products');
      if (section) alignNav(section);
    });
  }

  function prefetch(el) {
    var url = el && el.getAttribute('data-tab-url');
    if (url) fetchTab(url);
  }

  function lazyFor(tabId) {
    var panel = document.getElementById(tabId);
    return panel ? panel.querySelector('.products-feed__lazy') : null;
  }

  function bind() {
    document.querySelectorAll('[data-tab-target]').forEach(function (btn) {
      if (btn.dataset.lazyBound === 'true') return;
      btn.dataset.lazyBound = 'true';

      var target = btn.getAttribute('data-tab-target');

      btn.addEventListener('click', function () {
        var el = lazyFor(target);
        if (el) render(el);
      });

      // Prefetch: al pasar el mouse (desktop) o al primer toque (mobile).
      ['pointerenter', 'touchstart'].forEach(function (evt) {
        btn.addEventListener(
          evt,
          function () {
            prefetch(lazyFor(target));
          },
          { passive: true, once: true }
        );
      });
    });

    // Prefetch de la pestania siguiente cuando el navegador esta libre.
    var first = document.querySelector('.products-feed__lazy');
    if (first) {
      var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
      idle(function () {
        prefetch(first);
      });
    }

    bindAlign();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  window.addEventListener('load', bindAlign);
  document.addEventListener('shopify:section:load', bind);
})();
